export default class BucketError extends Error {
  name = 'BucketError'
  isUrlExpired = false
  status = 0
  statusText = ''

  constructor(presignedUrl, response) {
    super('An error while fetching data from your bucket', { cause: response.statusText })
    this.status = response.status
    this.statusText = response.statusText
    if (response.status === 400 || response.status === 403) {
      this.isUrlExpired = this.getIsUrlExpired(presignedUrl)
    }
  }

  getIsUrlExpired(presignedUrl) {
    const urlSearchParams = new URL(presignedUrl).searchParams
    // Google
    if (urlSearchParams.has('Expires')) {
      return Number.parseInt(urlSearchParams.get('Expires')) < Math.floor(Date.now() / 1000)
    }
    if (urlSearchParams.has('X-Goog-Expires')) {
      return this.isSignatureV4Expired(urlSearchParams.get('X-Goog-Date'), urlSearchParams.get('X-Goog-Expires'))
    }
    // Azure
    if (urlSearchParams.has('se')) {
      return new Date(urlSearchParams.get('se')).getTime() < Date.now()
    }
    // S3
    if (urlSearchParams.has('X-Amz-Expires')) {
      return this.isSignatureV4Expired(urlSearchParams.get('X-Amz-Date'), urlSearchParams.get('X-Amz-Expires'))
    }
    return false
  }

  isSignatureV4Expired(date, expires) {
    const dateStr = date.replace(/(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/, '$1-$2-$3T$4:$5:$6Z')
    return Number.parseInt(expires) * 1000 < Date.now() - new Date(dateStr).getTime()
  }
}
